import { z } from 'zod';

export const CommentEntityTypeSchema = z.enum([
  'APPLICATION',
  'ASSET',
  'FINDING',
  'SIGNAL',
  'EXECUTION_STATE',
  'ENDPOINT',
  'WEBPAGE',
]);

export const CommentSchema = z.object({
  id: z.string(),
  tenantId: z.string().nullable(),
  entityType: CommentEntityTypeSchema,
  entityId: z.string(),
  content: z.string(),
  createdBy: z.string().nullable(),
  parentCommentId: z.string().nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const CommentWithUserSchema = CommentSchema.extend({
  createdByUser: z
    .object({
      id: z.string(),
      name: z.string().nullable(),
      picture: z.string().nullable().optional(),
    })
    .nullable(),
});

export const CommentCreateSchema = CommentSchema.omit({
  id: true,
  tenantId: true,
  createdAt: true,
  updatedAt: true,
  createdBy: true,
});

export const CommentUpdateSchema = CommentCreateSchema.pick({
  content: true,
}).partial();

export const CommentsQuerySchema = z.object({
  entityType: CommentEntityTypeSchema,
  entityId: z.string(),
  lifecycleState: z
    .enum(['active', 'archived', 'all'])
    .optional()
    .describe('Filter by asset lifecycle state (active, archived, or all)'),
});

export const CommentsReturnSchema = z.object({
  comments: z.array(CommentWithUserSchema),
});

export const CommentReturnSchema = z.object({
  comment: CommentWithUserSchema,
});

export const CommentParamsSchema = z.object({
  commentId: z.string(),
});

export type Comment = z.infer<typeof CommentSchema>;
export type CommentWithUser = z.infer<typeof CommentWithUserSchema>;
export type CommentCreate = z.infer<typeof CommentCreateSchema>;
export type CommentUpdate = z.infer<typeof CommentUpdateSchema>;
export type CommentEntityType = z.infer<typeof CommentEntityTypeSchema>;
